import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchUploaded = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 33,
	viewBox: "0 0 31 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5714 29.5H3C1.61929 29.5 0.5 28.3807 0.5 27V3C0.5 1.61929 1.61929 0.5 3 0.5H14.6646C15.7311 0.5 16.7628 0.878744 17.576 1.56871L21.4828 4.88358C22.4905 5.73859 23.0714 6.99333 23.0714 8.31487V27C23.0714 28.3807 21.9521 29.5 20.5714 29.5Z",
			fill: "#44CC00",
			fillOpacity: .2,
			stroke: "#44CC00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2727 9H14.7727C14.4966 9 14.2727 8.77614 14.2727 8.5V8.5V3",
			stroke: "#44CC00",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 21.7727,
			cy: 24.5,
			r: 7.5,
			fill: "#44CC00",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2728 24.4998L21.1418 26.2498L24.2728 22.9998",
			stroke: "white",
			strokeWidth: 1.5
		})
	]
});
export default SvgBatchUploaded;
